import React, { useEffect, useState } from 'react';
import "./PostedLink.scss";
import { useAppContext } from '../../share-components/AppContext';
import { Button, Card } from 'react-bootstrap';
import { getActiveCategories, getPostedSocialLinks } from '../../services/ManagementService';
import Select, { components } from 'react-select';
import makeAnimated from 'react-select/animated';
import NoDataFound from '../../share-components/NoDataFound';
import FormTitle from '../../share-components/FormTitle';
import { SERVER_ERROR_MESSAGE } from '../../constants/commonConstants';

const PostedLink = () => {
    const { setLoading, setShowApiErrorMessage, setRouteNaviData } = useAppContext();
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [postedLinks, setPostedLinks] = useState([]);
    const [isCopied, setIsCopied] = useState(false);
    const animatedComponents = makeAnimated();
    const [isFirstLoaded, setIsFirstLoaded] = useState(false);

    const allSelected = selectedCategories?.length > 0 && selectedCategories?.length === categoryOptions?.length;

    const fetchCategories = async () => {
        setLoading(true);
        try {
            const response = await getActiveCategories();
            let activeCategories = (response || [])?.sort((a, b) => (a.categoryName || "")?.localeCompare((b?.categoryName || "")));
            // let activeCategories = response || [];
            let category_options = activeCategories?.map(category => ({
                value: category.categoryId,
                label: category.categoryName
            }));
            setCategoryOptions(category_options);
            // setCategories(response);
            setIsFirstLoaded(true);
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        setRouteNaviData("MANAGEMENT >> SOCIAL LINKS");
        fetchCategories();
    }, []);

    const handleChange = (selected) => {
        setSelectedCategories(selected || []);
    };

    const handleLoadPostedLink = async () => {
        setLoading(true);
        try {
            let selectedIds = selectedCategories?.map(selected => (
                selected.value
            ));
            let formData = {
                targetCategoryIdList: selectedIds
            }
            const response = await getPostedSocialLinks(formData);
            const sortedResponse = (response.socialPostedLinks || []).sort((a, b) => a.categoryName.localeCompare(b.categoryName));
            setPostedLinks(sortedResponse);
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
        } finally {
            setLoading(false);
        }
    }

    const handleCopyLinks = () => {
        const copyBlock = document.querySelector('.copy-block');
        if (copyBlock) {
            const textToCopy = copyBlock.innerText;
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    setIsCopied(true)
                    setTimeout(() => {
                        setIsCopied(false);
                    }, 5000);
                })
                .catch((err) => {
                    console.error('Failed to copy text: ', err);
                });
        }
    }

    const handleSelectAllChange = () => {
        if (allSelected) {
            setSelectedCategories([])
        } else {
            setSelectedCategories(categoryOptions || []);
        }
    }

    return (
        <>
            <div id='postedLink' style={{ paddingBottom: '50px' }}>
                <FormTitle title={"Posted Social Links"} isCenter={true} />

                {isFirstLoaded && <div style={{ padding: '10px', margin: '0 auto', maxWidth: '650px' }}>
                    <Card>
                        <Card.Body className='pt-2 mb-4'>
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div style={{ maxWidth: "550px" }}>
                                        <div className='mb-3'>
                                            <div>
                                                <input type='checkbox' id='select-all'
                                                    checked={allSelected}
                                                    onChange={handleSelectAllChange}
                                                    disabled={!categoryOptions || categoryOptions?.length <= 0}
                                                ></input>
                                                <label className='custom-label' htmlFor="select-all" style={{ marginLeft: '5px', cursor: 'pointer' }}
                                                >
                                                    {allSelected ? 'Deselect All' : 'Select All'}
                                                </label>
                                            </div>
                                            <Select
                                                closeMenuOnSelect={false}
                                                components={animatedComponents}
                                                value={selectedCategories}
                                                isMulti
                                                options={categoryOptions}
                                                onChange={handleChange}
                                                placeholder="Select one or more Categories..."
                                            />
                                            <Button
                                                className="w-100 mt-3"
                                                type="button"
                                                variant="primary"
                                                onClick={handleLoadPostedLink}
                                                disabled={!selectedCategories || selectedCategories.length <= 0}
                                            >
                                                Get Posted Social Links
                                            </Button>
                                        </div>

                                        {/* <p>
                                            ✅ &#x2705; |
                                            ⭐️ &#x2B50;&#xFE0F; |
                                            🌟 &#x1F31F;
                                        </p> */}

                                        {postedLinks && postedLinks.length > 0 ? <div className='social-links-block'>
                                            <button type='button' className='copy-btn' onClick={handleCopyLinks}>{isCopied ? "Copied!" : "Copy"}</button>
                                            <div className='copy-block p-3'>
                                                {postedLinks?.map(postedLink => (
                                                    <span key={postedLink?.categoryId}>
                                                        <span>&#x1F31F;{postedLink?.categoryName}</span><br />
                                                        {(postedLink?.socialLinks || []).map((linkInfo, index) => (
                                                            <span key={index}>
                                                                <span>&#x2705;{linkInfo.brandName} {linkInfo.productName}</span><br />
                                                                <span>{linkInfo.postedLink}</span><br /><br />
                                                            </span>
                                                        ))}
                                                    </span>
                                                ))}
                                            </div>
                                        </div> :
                                            <div >
                                                <NoDataFound></NoDataFound>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>}
            </div>
        </>
    );
}

export default PostedLink;